import { EMoneySource } from '../../../types/reducers/user';

type TParams = {
  isSubagent: boolean;
  selectedMoneySource: EMoneySource | null;
  isInsufficientFunds: boolean;
  isPublicationSubagentLimitExceed: boolean;
};

export const shouldChangeMoneySourceToSelf = ({
  isInsufficientFunds,
  isSubagent,
  selectedMoneySource,
  isPublicationSubagentLimitExceed,
}: TParams): boolean =>
  isSubagent &&
  selectedMoneySource === EMoneySource.Master &&
  (isInsufficientFunds || isPublicationSubagentLimitExceed);
